export enum EPagination {
  PER_PAGE = "per_page",
  CURRENT_PAGE = "current_page",
  TOTAL = "total",
  TOTAL_PAGES = "total_pages",
}
